// Hand-updated each release. A stat with `value: null` stays hidden until it has a real number.
export interface TrustStat {
  label: string;
  value: number | null;
  suffix?: string;
}

export const TRUST_STATS: TrustStat[] = [
  { label: "Gyms", value: 5 },
  { label: "Coaches", value: 20 },
  { label: "Athletes", value: 1200, suffix: "+" },
  { label: "Workouts logged", value: null, suffix: "+" },
];
